<template>
  <div class="">
    <h2 class="page-titles">{{ groupOrderDetails.name }}</h2>

    <GroupOrderHeaderBanner
      :title="'Add a card with message'"
      :headerText="'Cards'"
      :currentStep="creatingGroupOrderStep"
      @onPrevStep="handlePrevStep"
      @onNextStep="handleNextStep"
      @onSkipStep="
        $router.push({
          name: isEdit ? 'EditGroupOrderInfo' : 'GroupOrderInfo',
          params: { id: id, isEdit: isEdit }
        })
      "
      :canSkip="true"
    />

    <!-- Card message here -->
    <!-- Feature Hidden-->
    <div style="display: none" class="form-arena inter">
      <p class="form-arena-label">Card Message</p>
      <form @submit.prevent>
        <div class="form-group mini">
          <select
            class="minimal"
            v-model="selectedTemplateId"
            @input="onSelectedTemplateChange($event)"
          >
            <option value="" disabled selected>Select from templates</option>
            <option
              v-for="cardTemplate in cardTemplatesList"
              :key="cardTemplate.id"
              :value="cardTemplate.id"
              >{{ cardTemplate.name }}</option
            >
          </select>
        </div>
        <transition name="fade">
          <div class="form-group" v-show="saveTemplate">
            <label for="name">Template name</label>
            <input
              type="text"
              id="name"
              class="form-control"
              v-model="templateName"
            />
          </div>
        </transition>
        <div class="form-group relative mb-0">
          <textarea
            :maxlength="maxCharacters"
            placeholder="Type message"
            v-model="message"
          />
          <span class="characters-count"
            >{{ charactersLeft }} characters left</span
          >
        </div>
        <div class="form-group flex-center save-template">
          <label class="checkbox-container">
            <p class="">Save as new a template</p>
            <input type="checkbox" v-model="saveTemplate" />
            <span class="checkmark"></span>
          </label>
        </div>
      </form>
    </div>

    <!-- Card Arena -->
    <div class="card-region">
      <div class="flex gap-4 items-center margin-top-3 tier-product-info">
        <div class="form-label">
          <p>
            <strong
              >Add cards to this order by selecting from items below:</strong
            >
          </p>
        </div>
      </div>
      <div class="cards-display">
        <Card @handleCard="handleCard" :id="id" />
      </div>
    </div>
  </div>
</template>

<script>
import Card from '../Universal/ChooseCard'
import { mapState } from 'vuex'
import {
  cardStates,
  layouts,
  isPrintedCard,
  isPersonalizedCard
} from '@/helpers'
import i18n from '../../internatinalization/i18n'
import GroupOrderHeaderBanner from './GroupOrderHeaderBanner'

export default {
  name: 'addCard',
  props: ['id', 'isEdit'],

  data: () => ({
    activeCard: {},
    isPersonalized: false,
    saveTemplate: false,
    selectedCardTemplate: {},
    cardMessage: '',
    templateName: ''
  }),

  components: { Card, GroupOrderHeaderBanner },

  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.PAIGE_DASHBOARD)
    this.$store.dispatch('groupOrder/getGroupOrder', this.id)
    this.$store.dispatch('cardTemplate/getCardTemplates', {})
    this.$store.commit('groupOrder/CREATING_GROUP_ORDER_STEP', 4)
  },

  computed: {
    message: {
      get() {
        // return this.$store.state.groupOrder.groupOrderDetails.cardMessage
        if (this.selectedTemplateId) {
          return this.cardTemplatesList.find(
            card => card.id === this.selectedTemplateId
          ).message
        } else {
          return this.$store.state.groupOrder.groupOrderDetails.cardMessage
        }
      },
      set(value) {
        this.$store.dispatch('groupOrder/setCardMessage', value)
      }
    },
    selectedTemplateId: {
      get() {
        return this.$store.state.groupOrder.selectedTemplateId
      },
      set(value) {
        this.$store.dispatch('groupOrder/setSelectedTemplate', value)
      }
    },

    personalizedCard() {
      const card = this.activeCard.attributes
      const tagList = isPersonalizedCard(card && card.tagList)
      const typeList = isPersonalizedCard(card && card.typeList)
      return tagList || typeList
    },
    ...mapState({
      groupOrderDetails: state => state.groupOrder.groupOrderDetails,
      groupOrderTiers: state => state.groupOrder.groupOrderTiers,
      cardList: state => state.cardTemplate.cardList,
      maxCharacters: state => state.order.maxCharacters,
      cardTemplatesList: state => state.cardTemplate.cardTemplatesList,
      creatingGroupOrderStep: state => state.groupOrder.creatingGroupOrderStep
    }),

    computedCards() {
      return this.cardList.filter(
        card =>
          isPrintedCard(card.attributes && card.attributes.tagList) ||
          isPrintedCard(card.attributes && card.attributes.typeList)
      )
    },

    charactersLeft() {
      return this.message
        ? this.maxCharacters - this.message.length
        : this.maxCharacters
    },

    buttonText() {
      const isRedemption = this.$route.path.includes('redemption')
      return isRedemption ? 'Back' : 'Back to Product Selection'
    }
  },

  methods: {
    onSelectedTemplateChange(event) {
      if (event.target.value > 0) {
        let cardTemplate = this.cardTemplatesList.find(
          template => template.id === event.target.value
        )
        this.$store.dispatch(
          'groupOrder/setSelectedTemplate',
          event.target.value
        )
        return this.$store.dispatch(
          'groupOrder/setCardMessage',
          cardTemplate.message
        )
      }
    },
    handleCard(card) {
      this.activeCard = card
      if (this.activeCard.id == cardStates.NO_CARD) {
        return (this.isPersonalized = false)
      }
      this.personalizedCard
        ? (this.isPersonalized = true)
        : (this.isPersonalized = false)
    },
    async next() {
      console.log(this.saveTemplate)

      if (this.saveTemplate) {
        const check = await this.handleSaveTemplateErrors()
        if (!check.length) {
          await this.$store.dispatch('cardTemplate/addCardTemplate', {
            name: this.templateName,
            message: this.$store.state.groupOrder.groupOrderDetails.cardMessage
          })
        }
      }

      if (!this.computedCards.length) {
        return this.$router.push({
          name: this.isEdit ? 'EditGroupOrderInfo' : 'GroupOrderInfo',
          params: { id: this.id, isEdit: this.isEdit }
        })
      }

      if (!this.activeCard.id) {
        return this.$store.dispatch('notification/pushNotification', {
          type: 'error',
          messages: [i18n.t('validations.empty-card')]
        })
      }

      if (this.activeCard.id == cardStates.NO_CARD) {
        return this.$router.push({
          name: this.isEdit ? 'EditGroupOrderInfo' : 'GroupOrderInfo',
          params: { id: this.id, isEdit: this.isEdit }
        })
      }

      if (this.activeCard.id != cardStates.NO_CARD) {
        if (this.personalizedCard) {
          // Check for empty message
          if (!this.message) {
            return this.$store.dispatch('notification/pushNotification', {
              type: 'error',
              messages: [i18n.t('validations.blank-template-body')]
            })
          }
        }
        // Check for Blank space as First Character
        if (/^\s/.test(this.message)) {
          return this.$store.dispatch('notification/pushNotification', {
            type: 'error',
            messages: [i18n.t('validations.blank-space')]
          })
        }
      }

      return this.$store.dispatch('groupOrder/addCard', {
        id: this.id,
        productId: this.activeCard.id,
        quantity: 1,
        isEdit: this.isEdit
      })
    },
    handleSaveTemplateErrors() {
      let errors = []
      if (!this.templateName) {
        errors.push(i18n.t('validations.blank-template-name'))
      }

      if (!this.message) {
        errors.push(i18n.t('validations.blank-template-body'))
      }

      if (errors.length) {
        this.$store.dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }

      return errors
    },

    addItem(data) {
      this.$store.dispatch('groupOrder/addItemToTier', {
        groupOrderId: data.id,
        tierId: data.groupOrderTiers[0].id,
        productId: this.activeCard.id,
        productType: 'Product'
      })
    },
    handlePrevStep() {
      this.$router.go(-1)
    },
    handleNextStep() {
      this.next()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.margin {
  margin-top: 3rem;
  margin-bottom: 2rem;
}

.holder {
  text-align: left;
  h2 {
    margin: 0;
    padding-bottom: 1.5rem;
  }
  h3 {
    font-size: 1.063rem;
    color: #24292c;
    padding-top: 4rem;
    padding-bottom: 1.75rem;

    span {
      font-weight: 400;
    }
  }

  .button-area {
    display: flex;
    justify-content: center;
    margin-top: 2rem;

    .button-gemnote--small {
      height: 2.5rem;
      width: auto;
      padding: 0 2rem !important;
    }
  }
}

.card-region {
  p {
    text-align: center;
    padding-bottom: 0.6rem;
    font-size: 1.3rem;
    font-weight: 400;

    &.card-info {
      font-size: 0.875rem;
    }
  }
  .divider {
    border-top: 8px solid $main-6;
  }
}

.minimal {
  color: #232220;
  font-weight: normal !important;
}

.save-template {
  margin-top: 0.5rem;
}
.checkbox-container {
  p {
    font-weight: 400 !important;
    font-size: 0.875rem;
    position: relative;
    top: -2px;
    margin-left: 30px;
  }
}
.tier-product-info {
  margin-top: 3rem;
  margin-bottom: 1rem;
  p {
    font-size: 0.875rem;
  }
}

.form-arena {
  margin-top: 1.25rem;
  padding: 1.6rem 1.66rem;
  border: 1px solid $main-6;
  border-radius: 2px;
  margin-bottom: 2rem;
  border-radius: 12px;
  display: flex;
  gap: 1rem;
  align-items: baseline;

  .form-arena-label {
    font-size: 0.875rem;
  }

  @media (max-width: 575.98px) {
    flex-direction: column;
    gap: 0;
  }

  @media (min-width: 576px) and (max-width: 767.98px) {
    flex-wrap: wrap;
  }

  p {
    color: #24292c;
    font-weight: bold;
    @media (max-width: 575.98px) {
      padding-bottom: 20px;
    }

    @media (min-width: 576px) and (max-width: 767.98px) {
      padding-bottom: 20px;
    }
  }

  .form-group textarea {
    background-color: transparent !important;
    font-size: 0.875rem;
    font-weight: 400;
  }
  .form-group.mb-0 {
    margin-bottom: 0px;
  }

  .form-group.mini {
    width: 50%;
    @media (max-width: 575.98px) {
      width: 100%;
    }
    @media (min-width: 576px) and (max-width: 767.98px) {
      width: 100%;
    }
    select {
      background: $dark-gray;
      font-size: 0.813rem;
      background-image: url('../../assets/dropdownarrow.svg');
      background-repeat: no-repeat;
      background-position: calc(100% - 14px) calc(1em + 7px),
        calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
    }
  }
  .characters-count {
    color: #a09c95;
    font-size: 0.65rem;
    margin: 0.5rem 0rem;
    float: right;
    position: relative;
    top: -0.7rem;
  }

  form {
    width: 83%;
    @media (max-width: 575.98px) {
      width: 100%;
    }

    .form-group textarea {
      font-size: 0.875rem;
      border: 1px solid $gray-variant-2;
      padding: 15px 20px;
      height: 150px;
      resize: none;
      &::placeholder {
        font-weight: 300;
        color: #a09c95;
      }
    }
  }
}
</style>
